export default {"src":"/_next/static/media/newo.3c9ae85e.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};